<template>
  <div class="flex grid-cols-2 flex-col gap-8 md:grid lg:grid-cols-12">
    <ProductDetailGallery
      class="gallery row-start-1 lg:col-start-1 lg:col-end-8 pdp:col-end-9"
      :product="product"
      :selected-variant="selectedVariant"
    ></ProductDetailGallery>
    <div
      class="actions row-start-1 row-end-4 lg:col-start-8 lg:col-end-13 pdp:col-start-9"
    >
      <slot name="actions" />
    </div>
    <div
      class="row-start-2 flex flex-col gap-8 md:flex-row md:flex-wrap lg:col-start-1 lg:col-end-8 pdp:col-end-9"
    >
      <ProductDetailTexts
        class="list-description grow pdp:order-2 pdp:max-w-[calc(50%-1rem)]"
        :get-attribute="getAttribute"
        type="list"
      />
      <div
        v-if="
          productDetailProperties &&
          productDetailProperties.length &&
          detailNameMapping
        "
        class="brand-and-attribute-table w-full shrink-0 grow pdp:order-4 pdp:max-w-[calc(50%-1rem)]"
      >
        <div class="flex flex-col gap-8">
          <div v-if="brand" class="mb-8 mt-4 flex flex-col xl:mt-0">
            <Headline tag="span" look="h3">
              {{ $t('pdp.product_detail_brand') }}
            </Headline>
            <p>
              {{ brand }}
            </p>
          </div>
          <ProductDetailAttributesTable
            :product="product"
            :detail-properties="productDetailProperties"
            :active-variant="selectedVariant"
            :translations="detailNameMapping"
          />
        </div>
      </div>
      <ProductDetailTexts
        class="short-description pdp:order-1 pdp:max-w-[calc(50%-1rem)]"
        :get-attribute="getAttribute"
        type="short"
      />
      <ProductDetailTexts
        class="long-description pdp:order-3 pdp:max-w-[calc(50%-1rem)]"
        :get-attribute="getAttribute"
        type="long"
      />
      <div v-if="slots.manuals" class="w-full grow pdp:order-5">
        <slot name="manuals" />
      </div>
      <div class="w-full grow pdp:order-5">
        <ProductDetailManufacturerDetails
          v-if="product.attributes"
          :product-attributes="product.attributes"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// https://aboutyou.atlassian.net/browse/SCFIM-1619
import type { AdvancedAttribute, AttributeGroup } from '@aboutyou/backbone'
import type { Product, Variant } from '@scayle/storefront-nuxt'

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  getAttribute: {
    type: Function as PropType<
      (
        key: string,
        full?: boolean,
      ) => string | AttributeGroup | AdvancedAttribute | null | undefined
    >,
    required: true,
  },
  productDetailProperties: {
    type: Array as PropType<string[]>,
    required: false,
    default: undefined,
  },
  detailNameMapping: {
    type: Object as PropType<Record<string, string>>,
    required: false,
    default: undefined,
  },
  selectedVariant: {
    type: Object as PropType<Variant | undefined>,
    default: undefined,
  },
})

const brand = computed(() =>
  getFirstAttributeLabel(props.product.attributes, 'brand'),
)

const slots = useSlots()
</script>
